import { get } from 'lodash'

export function getIsGO(): boolean {
  const tenantId: number = get(global, 'currentUser.tenant.id') || 0

  const isGO = [
    /(localhost|local|staging)/.test(window.location.href) ? 1 : -1,
    30,
    32,
    92,
  ].includes(tenantId)

  return isGO
}

export function getIsGOCH(): boolean {
  const tenantId: number = get(global, 'currentUser.tenant.id') || 0

  const isGOCH = [1].includes(tenantId)

  return isGOCH
}

export function getIsGODE(): boolean {
  const tenantId: number = get(global, 'currentUser.tenant.id') || 0

  const isGODE = [30, 32, 92].includes(tenantId)

  return isGODE
}
